import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const SelectorWrapper = styled.div(() =>
  mq({
    width: ['90%', '90%', '90%', '842px'],
    margin: [
      `0 auto ${defaultTheme.spacing.l}`,
      `0 auto ${defaultTheme.spacing.l}`,
      `0 auto ${defaultTheme.spacing.xxl}`,
      `0 auto ${defaultTheme.spacing.xxl}`,
    ],
  }),
);
